import { breakpoint } from '@/helpers/BreakpointHelper';
import { Link } from 'gatsby';
import React, { FC, ImgHTMLAttributes } from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import SwiperBasic from './Swiper/SwiperBasic';

interface ItemProps {
  itemData: DataItem[];
}

export interface DataItem {
  id: string | number;
  title: string;
  img: ImgHTMLAttributes<any>['src'];
}

const Carditem = styled.div`
  text-align: center;
  .img-wrap {
    display: inline-block;
    width: 100%;
    max-width: 161px;
    margin: 0 auto;
    padding: 16px 0;

    .img-box {
      padding-top: 54.04%;
    }
  }
  .dec-wrap {
    border-top: 1px solid #b7b8ba;
    font-weight: 700;
    padding-top: 16px;
    text-align: center;
  }
`;
const PcList = styled.ul`
  & > li {
    padding: 0 16px;
    width: 25%;
    margin-bottom: 97px;
  }
`;

const SwiperCustom = styled(SwiperBasic)`
  padding: 0;
  .swiper-container {
    overflow: hidden;
    margin-left: -7px;
    margin-right: -7px;
    .swiper-slide {
      width: 33.33%;
      padding: 0 7px;

      ${breakpoint(`mobile`)} {
        & {
          width: 50%;
        }
      }
    }
    .swiper-scrollbar {
      left: 7px;
      right: 7px;
    }
  }

  ${breakpoint(`tablet`)} {
  }
`;
const PartnerContainer = styled.div``;

const Partner: FC<ItemProps> = ({ itemData, ...props }) => (
  <PartnerContainer>
    <PcList className="m-hide flex">
      {itemData.map((row) => (
        <li className="list-item" key={row.id}>
          <Carditem>
            <Link to="/involve/corporate-and-organization/social-contribution">
              <div className="img-wrap">
                <div
                  className="img-box"
                  css={`
                    background-image: url(${row.img});
                  `}
                />
              </div>
            </Link>
            <div className="dec-wrap">
              <p>{row.title}</p>
            </div>
          </Carditem>
        </li>
      ))}
    </PcList>

    <SwiperCustom overflow className="pc-hide">
      <Swiper slidesPerView="auto" scrollbar={{ draggable: true }}>
        {itemData.map((row) => (
          <SwiperSlide key={row.id}>
            <Carditem>
              <Link to="/involve/corporate-and-organization/social-contribution">
                <div className="img-wrap">
                  <div
                    className="img-box"
                    css={`
                      background-image: url(${row.img});
                    `}
                  />
                </div>
                <div className="dec-wrap">
                  <p>{row.title}</p>
                </div>
              </Link>
            </Carditem>
          </SwiperSlide>
        ))}
      </Swiper>
    </SwiperCustom>
  </PartnerContainer>
);
export default Partner;
